const translations = {
    fr: {
        summary: "Résumé",
        keywords: "Mots-clés",
        additionalDocs: "Documents annexes",
        author: "Auteur(s)",
        authorLabel: "Auteur:",
        sourcesLabel: "Sources:",
        content: "Contenu",
        cite: "Citer l'article",
        submitted: " soumis le ",
        published: " publié le ",
        doi: "Non disponible",
        researchMaterials: "Matériel de recherche",
        noResearchMaterials: "Aucun matériel de recherche renseigné.",
        bibliographies: "Bibliographie",
        noBibliography: "Aucune bibliographie renseignée.",
        viewPdf: "Voir le PDF",
        download: "Télécharger",
        seeImage: "Voir l'image",
        loading: "Chargement...",
        notFound: "Article non trouvé",
        notFoundDesc: "L'article que vous recherchez n'existe pas.",
        noSummary: "Résumé non disponible.",
        noKeywords: "Aucun mot-clé disponible.",
    },
    en: {
        summary: "Summary",
        keywords: "Keywords",
        additionalDocs: "Additional Documents",
        author: "Author(s)",
        authorLabel: "Author:",
        sourcesLabel: "Sources:",
        content: "Content",
        cite: "Cite this article",
        submitted: " submitted on ",
        published: " published on ",
        doi: "Not available",
        researchMaterials: "Research materials",
        noResearchMaterials: "No research materials provided.",
        bibliographies: "Bibliographies",
        noBibliography: "No bibliography provided.",
        viewPdf: "View PDF",
        download: "Download",
        seeImage: "See image",
        loading: "Loading...",
        notFound: "Article not found",
        notFoundDesc: "The article you are looking for does not exist.",
        noSummary: "Summary not available in English.",
        noKeywords: "No keywords available in English.",
    },
    mg: {
        summary: "Famintinana",
        keywords: "Tenifototra",
        additionalDocs: "Taratasy fanampiny",
        author: "Mpandray anjara",
        authorLabel: "Mpandray anjara:",
        sourcesLabel: "Loharano:",
        content: "Votoaty",
        cite: "Manonona ity lahatsoratra ity",
        submitted: " nalefa ny ",
        published: " navoaka ny ",
        doi: "Tsy misy",
        researchMaterials: "Fitaovana fikarohana",
        noResearchMaterials: "Tsy misy fitaovana fikarohana voasoratra.",
        bibliographies: "Lahatsoratra mifandray",
        noBibliography: "Tsy misy lahatsoratra mifandray.",
        viewPdf: "Jereo PDF",
        download: "Sintomy",
        seeImage: "Jereo sary",
        loading: "Miandry...",
        notFound: "Tsy hita ny lahatsoratra",
        notFoundDesc: "Tsy misy ity lahatsoratra tadiavinao ity.",
        noSummary: "Tsy misy famintinana amin'ny teny malagasy.",
        noKeywords: "Tsy misy tenifototra amin'ny teny malagasy.",
    },
};

export default translations;